import React from 'react';
import MaUTable from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { useTable } from 'react-table';
import useStyles from './Table.styles';
import { NSTable } from '../../../types/interfaces/NSTable';
import { ETables } from '../../../types/enums/ETables';
import CellWithFilter from '../CellWithFilter/CellWithFilter';
import { shouldHasFilter } from '../../../utils/cellWithFilter';
import { getRowCellContent } from '../../../utils/jsxUtils';

const Table: React.FC<NSTable.IProps> = ({
  data,
  tableName = ETables.Customers,
  filterable = true,
  cellStyleHandler,
  columns,
  handleCellClick,
}) => {
  const styles = useStyles();
  const { getTableProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  });

  return (
    <>
      <MaUTable {...getTableProps()} className={styles.container}>
        {headerGroups.map((headerGroup) => (
          <TableRow {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column: any, key) =>
              filterable && shouldHasFilter(column.id, tableName) ? (
                <CellWithFilter key={key} tableColumn={column} tableName={tableName} />
              ) : (
                <TableCell key={key} {...column.getHeaderProps()} className={styles.cell}>
                  {column.render('Header', column)}
                </TableCell>
              ),
            )}
          </TableRow>
        ))}

        <TableBody>
          {rows.map((row, key) => {
            prepareRow(row);
            return (
              <TableRow
                {...row.getRowProps()}
                className={styles.row}
                key={key}
                // onClick={() => (handleRowClick ? handleRowClick(row) : null)}
              >
                {row.cells.map((cell, key) => {
                  return (
                    <TableCell
                      {...cell.getCellProps()}
                      key={key}
                      className={cellStyleHandler && cellStyleHandler(cell)}
                      onClick={() => handleCellClick && handleCellClick(cell)}
                    >
                      {getRowCellContent(cell)}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </MaUTable>
      <div id="render-filter-portal"></div>
    </>
  );
};

export default Table;
